const mapParcel = parcel => {
  return {
    id: parcel.id,
    status: parcel.status,
    order: { name: parcel.order.name },
    customer_profile: parcel.customer_profile,
  }
}

export const transformResponseParcels = response => response.results.map(mapParcel)
